import { Status } from "../../models/Status";

export const CONFIRM_ACCOUNT_STATUS = "CONFIRM_ACCOUNT_STATUS";

export type IState = {
  status: Status;
};
